import { styled } from '@stitches/react'
import { red1 } from '../platform/color'

export const FieldErrorLabel = styled('span', {
  fontSize: '11px',
  lineHeight: '12px',
  fontWeight: 500,
  color: red1,
  display: 'flex',
  width: '100%',
  padding: '0px',
  marginBottom: '12px'
})
